var HeavyHelmet = function (quality) {
  return {
    slot: 'helmet',
    type: 'heavy',
    quality: quality,
    armorClass: Math.round(8 + quality * 55),
  };
};
module.exports = HeavyHelmet;
